import { render } from "./FpSelectBox.vue?vue&type=template&id=3dc031e6&scoped=true"
import script from "./FpSelectBox.vue?vue&type=script&lang=js"
export * from "./FpSelectBox.vue?vue&type=script&lang=js"

import "./FpSelectBox.vue?vue&type=style&index=0&id=3dc031e6&lang=scss&scoped=true"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc031e6"]])

export default __exports__